import React from 'react';
import { FormikErrors, useFormikContext } from 'formik';

export const scrollToErrorField = (errors: FormikErrors<unknown>) => {
  const orderedErrorElements = Object.keys(errors).reduce((prev, errorKey) => {
    const element = document.querySelector(`[name=${errorKey}]`);

    return element ? [ ...prev, element ] : prev;
  }, Array.of<Element>()).sort((a, b) => a.getBoundingClientRect().top - b.getBoundingClientRect().top);

  const firstErrorElement = orderedErrorElements[0];

  if (!firstErrorElement) {
    return;
  }

  firstErrorElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
};

export const AutoScrollToErrorField = () => {
  const { submitCount, isValid, errors } = useFormikContext<unknown>();

  React.useEffect(() => {
    // do not scroll if form is valid
    if (isValid) {
      return;
    }

    scrollToErrorField(errors);

    // execute effect only when submitCount change
  }, [ submitCount ]); // eslint-disable-line react-hooks/exhaustive-deps

  return null;
};
